import s from './sidebar.module.scss'
import { NavLink } from 'react-router-dom'
import { IconHeadphones, IconHistory, IconHome, IconInfoCircle, IconLogout, IconMenu2, IconMessages, IconReceipt, IconSearch, IconSettings, IconUsersPlus } from '@tabler/icons-react'
import classNames from 'classnames'
import { Button } from '@shared/ui/button/button'
import { SupportButton } from '@shared/ui/support-button'
import { useChatStore } from '@entities/messanger/model/chat.store'
import { TimezoneButton } from '@features/profile/timezone'
import { auth } from '@shared/api/services'
import { version } from 'info'

export const LeftSidebar = ({isHidden, isDynamic, active, className, closeSidebar, profile, isTablet}) => {
	const chats = useChatStore((state) => state.chats)

	return (
		<div className={classNames(className, s.leftSidebar, isTablet ? s.tablet : '', isDynamic ? s.dynamic : '',  isHidden ? s.hidden : null, active ? s.active : null)}>
			<div>
				<div className={s.burgerWrapper}>
					{isHidden && 	<button onClick={() => closeSidebar()} className={s.burger}>
							<IconMenu2/>
						</button>}
					<div className={s.logo}>
						<img src={isTablet ? process.env.REACT_APP_STORAGE_URL + "images/logo-tablet.svg" : process.env.REACT_APP_STORAGE_URL + "images/logo.svg"} alt="Созвучно - сервис по поиску преподавателей музыки" />
					</div>
				</div>
				<div className={s.menu}>
					<p>Основное меню</p>
					{{'student':<ul>
						<li>
							<NavLink to={'/'} className={({ isActive }) =>  isActive ? s.active : ""}><IconHome/> <span>Главная</span></NavLink>
						</li>
						<li className={classNames(s.messenger, chats?.findIndex(_ => _?.last_message && _?.last_message?.sender_id !== profile.id && !_?.last_message?.is_read) !== -1 ? s.unread : '')}>
							<NavLink to={'/messenger'} className={({ isActive }) =>  isActive ? s.active : ""}><IconMessages/> <span>Чаты</span></NavLink>
						</li>
						<li>
							<NavLink to={'/teachers'} className={({ isActive }) =>  isActive ? s.active : ""}><IconSearch/> <span>Заниматься</span></NavLink>
						</li>
						<li>
							<NavLink to={'/history'} className={({ isActive }) =>  isActive ? s.active : ""}><IconHistory/><span>Мои занятия</span></NavLink>
						</li>
					</ul>,
					'teacher':<ul>
						<li>
							<NavLink to={'/'} className={({ isActive }) =>  isActive ? s.active : ""}><IconHome/> <span>Главная</span></NavLink>
						</li>
						<li className={classNames(s.messenger, chats?.findIndex(_ => _?.last_message && _?.last_message?.sender_id !== profile.id && !_?.last_message?.is_read) !== -1 ? s.unread : '')}>
							<NavLink to={'/messenger'} className={({ isActive }) =>  isActive ? s.active : ""}><IconMessages/> <span>Чаты</span></NavLink>
						</li>
						<li>
							<NavLink to={'/history'} className={({ isActive }) =>  isActive ? s.active : ""}><IconHistory/> <span>Мои занятия</span></NavLink>
						</li>
						<li>
							<NavLink to={'/referrals'} className={({ isActive }) =>  isActive ? s.active : ""}><IconUsersPlus/> <span>Рефералы</span></NavLink>
						</li>
						<li>
							<NavLink to={'/payment-history'} className={({ isActive }) =>  isActive ? s.active : ""}><IconReceipt/> <span>История выплат</span></NavLink>
						</li>
					</ul>}[profile?.role]}
					<p>Вспомогательное меню</p>
					<ul>
						<li>
							<NavLink to={'/settings'} className={({ isActive }) =>  isActive ? s.active : ""}><IconSettings/> <span>Настройки</span></NavLink>
						</li>
						<li>
							<SupportButton
								label={isTablet ? null : 'Поддержка'}
								icon={IconHeadphones}
								theme="secondary"
								size="small"
								className={s.supportWrapper}
								buttonClassName={s.supportButton}
								placement="bottom-start"
								chatOnly={isTablet}
							/>
						</li>
						<li>
							<NavLink to={'/info'} className={({ isActive }) =>  isActive ? s.active : ""}><IconInfoCircle/> <span>Информация</span></NavLink>
						</li>
					</ul>
				</div>
			</div>
			{isTablet ? null : 
			<div className={s.profile}>
				<div className={s.avatar}>
					<img src={profile.avatar ?process.env.REACT_APP_STORAGE_URL + profile.avatar.image : process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'} alt="" />
				</div>
				<div className={s.profileContent}>
					<div className={s.name}>{profile?.name}</div>
					<div className={s.role}>{profile?.role === 'student' ? 'Ученик' : "Преподаватель"}</div>
				</div>
			</div>}
			{!isTablet && 
			<div className={s.timezoneWrapper}>
				<TimezoneButton/>
			</div>
			}
			
			<Button label={isTablet ? null : 'Выйти'} lefticon={isTablet ? <IconLogout/> : null} className={s.logout} onClick={() => auth.logout()}/>
			<span className={s.version}>{version}</span>
		</div>
	)
}
